import { protocol } from './index'

const URL_UPDATE_WATER_MEASUREMENT_UNIT = '/api/updateWaterMeasurementUnit'
export const postUpdateWaterMeasurementUnit = (preferredWater: number) => {
  return protocol.post(
    `${URL_UPDATE_WATER_MEASUREMENT_UNIT}?preferredWater=${preferredWater}`,
    {},
  )
}

const URL_UPDATE_PREFERENCE_SETTINGS = '/api/UpdatePreferenceSettings'
export const postUpdatePreferenceSettings = (
  preferredWater: number,
  receivePublicityMaterials: boolean,
) => {
  return protocol.post(URL_UPDATE_PREFERENCE_SETTINGS, {
    preferredWaterMeasurement: preferredWater,
    receivePublicityMaterials: receivePublicityMaterials,
  })
}

const URL_GET_USER_NOTIFICATION_SETTINGS = '/api/GetUserNotificationSettings'
export const getUserNotificationSettings = () => {
  return protocol.get(`${URL_GET_USER_NOTIFICATION_SETTINGS}`)
}

const URL_UPDATE_USER_NOTIFICATION_SETTINGS = '/api/UpdateNotificationSettings'
export const postUpdateUserNotificationSettings = (payload: any) => {
  return protocol.put(`${URL_UPDATE_USER_NOTIFICATION_SETTINGS}`, payload)
}

const URL_PUT_USER_PHOTO = '/api/uploadProfilePhoto'
export const putUserPhoto = (file: File) => {
  const formData = new FormData()
  formData.append('ProfilePhoto', file)
  return protocol.put(URL_PUT_USER_PHOTO, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

const URL_POST_UPDATE_USER_PROFILE = '/api/UpdateUserProfile'
export const postUpdateUserProfile = (payload: {
  name: string
  dateOfBirth: string
  emailAddress: string
}) => {
  return protocol.post(URL_POST_UPDATE_USER_PROFILE, payload)
}

const URL_GET_USER_INFO = '/api/getUserInfo'
export const getGetUserInfo = () => {
  return protocol.post(`${URL_GET_USER_INFO}`, {})
}

const URL_GET_PROFILE_PHOTO = '/api/getProfilePhoto'
export const getProfilePhoto = () => {
  return protocol.get(URL_GET_PROFILE_PHOTO)
}

const URL_PUT_UPDATE_CONTACT_NO = '/api/updateContactNo'
export const putUpdateContactNumber = (payload: any) => {
  return protocol.put(URL_PUT_UPDATE_CONTACT_NO, payload)
}

const URL_PUT_UPDATE_CONTACT_NO_WITHOUT_LOGIN = '/api/updateContactWithoutLogin'
export const putUpdateContactNumberWithoutLogin = (payload: any) => {
  return protocol.put(URL_PUT_UPDATE_CONTACT_NO_WITHOUT_LOGIN, payload)
}

const URL_PUT_UPDATE_EMAIL_ADDRESS = '/api/UpdateEmailAddress'
export const putUpdateEmailAddress = (payload: any) => {
  return protocol.put(URL_PUT_UPDATE_EMAIL_ADDRESS, payload)
}

const URL_POST_CHECK_ELIGIBLE_CONTACT_WITHOUT_LOGIN =
  '/api/checkEligibleContactWithoutLogin'
export const checkEligibleContactWithoutLogin = (payload: any) => {
  return protocol.post(URL_POST_CHECK_ELIGIBLE_CONTACT_WITHOUT_LOGIN, payload)
}

const URL_POST_VALIDATE_CONTACT_WITHOUT_LOGIN =
  '/api/validateContactWithoutLogin'
export const validateContactWithoutLogin = (payload: any) => {
  return protocol.post(URL_POST_VALIDATE_CONTACT_WITHOUT_LOGIN, payload)
}
